import Vue from 'vue'
import axios from 'axios'
import store from '../store/index'
import { SECONDARY } from '@/mixins/multiResourceMixin'
import Utils from '@/helpers/Utils'
import { TOKEN_PIN } from '@/views/PinEnter.vue'
import { SIMULATOR } from '@/views/Login.vue'
import router from '@/router/index'

Vue.prototype.$getCookie = function(name: string) {
  const cookieValue = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
  return cookieValue ? cookieValue.pop() : '';
}

const env = process.env
const token = store.getters.getToken
const lastLoggedInUser = store.getters.getLastLoggedInUser
const identifierSlave = sessionStorage.getItem(SECONDARY)
const tokenPin = sessionStorage.getItem(TOKEN_PIN)
const simulator = sessionStorage.getItem(SIMULATOR)
const darkMode = (localStorage.getItem('theme') === 'dark' || (localStorage.getItem('theme') === 'system' && window.matchMedia('(prefers-color-scheme: dark)').matches))
const userAppVersion = sessionStorage.getItem('appVersion') || null
const language = sessionStorage.getItem(env.VUE_APP_HEADER_LANGUAGE)

// axios.defaults.withCredentials = true;

axios.defaults.baseURL = env.VUE_APP_AXIOS_BASE_URL
axios.defaults.timeout = env.VUE_APP_AXIOS_TIMEOUT
axios.defaults.headers.common = {
  [env.VUE_APP_HEADER_APP_ID]: env.VUE_APP_APP_ID,
  [env.VUE_APP_HEADER_APP_VERSION]: userAppVersion || env.VUE_APP_APP_VERSION,
  [env.VUE_APP_HEADER_API_ID]: env.VUE_APP_API_ID,
  [env.VUE_APP_HEADER_API_VERSION]: env.VUE_APP_API_VERSION
}

if (token !== '') {
  axios.defaults.headers.common[env.VUE_APP_HEADER_TOKEN] = token
}
if (darkMode) {
 axios.defaults.headers.common[env.VUE_APP_HEADER_DARK_MODE] = 'true'
}
if (identifierSlave) {
  axios.defaults.headers.common[env.VUE_APP_HEADER_SLAVE] = identifierSlave
}

if (tokenPin) {
  axios.defaults.headers.common[env.VUE_APP_HEADER_PIN_TOKEN] = tokenPin
}

if (simulator) {
  axios.defaults.headers.common[env.VUE_APP_ADMIN_HEADER] = simulator
}

if (language) {
  axios.defaults.headers.common[env.VUE_APP_HEADER_LANGUAGE] = language
}

const _axios = axios.create()

_axios.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    let lastLoggedInUserNow = Vue.prototype.$getCookie('last-logged-in-user');
    if (token && (!lastLoggedInUserNow || !lastLoggedInUser || lastLoggedInUser !== lastLoggedInUserNow)) {
      store.state.token = ''
      store.state.lastLoggedInUser = ''
      localStorage.clear()
      sessionStorage.clear()
      router.push('/login')
    }
    return config
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error)
  }
)

// Add a response interceptor
_axios.interceptors.response.use(
  function (response) {
    // Do something with response data
    if (response.data && response.data.data && response.data.data.has_pin) {
      store.commit('setHasPin', true)
    }
    return response
  },
  async function (error) {
    // If a timeout occurs, a way to check for it is if error.code === 'ECONNABORTED'
    if ((error.code && error.code === 'ECONNABORTED') || (error.response && error.response.status >= 500)) {
      store.state.errorOccurred = true
      await router.push({ name: 'Error' }).catch(() => { /* Do nothing */ })
    }
    // '401 Unauthorized' is the error we get from the server if a token has expired or doesn't exist
    if (error.response && error.response.status === 401) {
      store.state.token = ''
      Utils.finalizeLogout()
    }
    return Promise.reject(error)
  }
)

export default _axios
